import script from "./DeliveryFooterCard.vue?vue&type=script&lang=ts&setup=true"
export * from "./DeliveryFooterCard.vue?vue&type=script&lang=ts&setup=true"

import "./DeliveryFooterCard.vue?vue&type=style&index=0&id=7ee2533e&lang=less&scoped=true"

import exportComponent from "/var/build/production/construction-site-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7ee2533e"]])

export default __exports__